<template>
	<!-- 设备参数表 -->
	<div id="parameter-table">
		<div class="header">
			<div class="title flex middle">
                <template>
                    <div>
                        <img :src="parameter.title.icon" alt="" class="icon">
                        <h1 class="parameter-table-title">{{ parameter.title.name }}</h1>
                    </div>
                </template>
			</div>
		</div>
		<div class="table-body">
			<div
				class="table-row flex bCenter"
				:class="index"
				v-for="(item, index) in parameter.tableTh"
				:key="index">
				<div class="row-name">{{ item }}</div>
				<template class="flex">
                    <!-- :style="{width: `${100/parameter.tableTr.length || 0}%`}" -->
					<div
                        class="row-column"
						v-for="(citem, cindex) in parameter.tableTr"
						:key="cindex">
						<template v-if="index === 'discNoRepeat'">
							<div class="disc-no-repeat flex column bCenter">
								<div class="img flex middle center">
									<img :src="citem.discNoRepeat.cover">
								</div>
								<p>{{ citem.discNoRepeat.name }}</p>
							</div>
						</template>
						<template v-else>
							{{ citem[index] }}
						</template>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		parameter: {
			type: Object,
			default: ()=> {
				return {}
			}
		},
	},
	data() {
		return {

		}
    },
    // mounted(){
    //     $('[data-am-scrollspy]').scrollspy();
    // },
}
</script>

<style lang="less" scoped>
#parameter-table {
    padding: 13px 0 65px;
    overflow: hidden;
	.header {
		font-size: 18px;
		.title {
			border-bottom: 1px solid #999999;
			.icon {
				width: 47px;
				height: 47px;
				vertical-align: middle;
			}
			span {
				font-size: 18px;
				// font-family: Source Han Sans CN, Source Han Sans CN-Medium;
				font-weight: 500;
				color: #333333;
				line-height: 37px;
			}
			.parameter-table-title{
				display: inline;
				color: #333;
			}
		}
	}
	.table-body {
		.table-row {
			>div {
				flex: 1;
				font-size: 18px;
				// font-family: Source Han Sans CN, Source Han Sans CN-Medium;
				font-weight: 500;
				color: #333333;
				line-height: 36px;
				padding: 0 36px;
				.disc-no-repeat {
					text-align: center;
					height: 100%;
					.img {
                        // flex: 1;
                        flex-grow: 1;
						img {
							vertical-align: middle;
                            margin: 50px 0;
						}
						+p {
							font-size: 24px;
							// font-family: Source Han Sans CN, Source Han Sans CN-Bold;
							font-weight: 700;
							color: #333333;
							line-height: 37px;
							margin-bottom: 45px;
						}
					}
				}
				&.row-name {
					max-width: 220px;
                }
                &.row-column {
                    text-align: left !important;
                }
                &:nth-child(2) {
                    text-align: center;
                }
                &:last-child {
                    text-align: center;
                }
			}
			&.xh >div {
				border-top: 1px solid #707070;
				border-bottom: 1px solid #707070;
				padding: 37px 36px;
				font-size: 24px;
				// font-family: Source Han Sans CN, Source Han Sans CN-Bold;
				font-weight: 700;
				color: #333333;
				line-height: 37px;
                margin-bottom: 37px;
                &:nth-child(2) {
                    text-align: center !important;
                }
                &:last-child {
                    text-align: center !important;
                }
			}
		}
	}
}
</style>
